
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class StockTypeField extends Vue {
  @Prop()
  placeholder?: string;

  @Prop()
  value?: any;

  @Prop()
  multiple?: boolean;

  @Prop()
  filterable?: boolean;

  @Prop()
  allowCreate?: boolean;

  @Prop()
  readonly?: boolean;

  val = '';

  options = [
    {
      value: '1',
      label: '总库存',
    },
    {
      value: '2',
      label: '剩余库存',
    },
  ];

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = this.value;
    } else {
      this.val = '';
    }
  }

  handleChange(val: string) {
    this.val = val;
    this.$emit('input', val);
  }
}
